export default [{
    path: '/',
    name: 'home',
    meta: {
      title: 'hd.home'
    },
    component: resolve => require(['@/pages/views/home/home.vue'], resolve)
  }, {
    path: '/r/:id',
    name: 'referrer',
    meta: {
      title: '来自好友的邀请注册'
    },
    component: resolve => require(['@/pages/common/referrer.vue'], resolve)
  },
  {
    path: '/trade',
    name: 'trade',
    meta: {
      title: 'hd.currency'
    },

    component: resolve => require(['@/pages/views/trade/common/index.vue'], resolve),
    children: [{
        path: '/exchange',
        name: 'exchange',
        meta: {
          title: 'hd.currency'
        },
        component: resolve => require(['@/pages/views/trade/exchange/exchange.vue'], resolve)
      }, {
        path: '/exchange/:pair',
        name: 'exchange2',
        meta: {
          title: 'hd.currency'
        },
        component: resolve => require(['@/pages/views/trade/exchange/exchange.vue'], resolve)
      },
      // {
      //     path: '/Information',
      //     name: 'Information',
      //     meta: {
      //         title: '币种资料'
      //     },
      //     component: resolve => require(['@/pages/views/trade/Information/Information.vue'], resolve)
      // },{
      //     path: '/Information/:pair',
      //     name: 'Information2',
      //     meta: {
      //         title: '币种资料'
      //     },
      //     component: resolve => require(['@/pages/views/trade/Information/Information.vue'], resolve)
      // },
    ]
  },
  {
    path: '/otcTrade',
    name: 'otcTrade',
    meta: {
      title: 'hd.otc_trade'
    },
    component: resolve => require(['@/pages/views/otcTrade/index.vue'], resolve)
  }, {
    path: '/otcTrade/:market',
    name: 'otcTrade',
    meta: {
      title: 'hd.otc_trade'
    },
    component: resolve => require(['@/pages/views/otcTrade/index.vue'], resolve)
  },
  {
    path: '/c2cTrade',
    name: 'c2cTrade',
    meta: {
      title: 'hd.c2c_trade'
    },
    component: resolve => require(['@/pages/views/c2cTrade/index.vue'], resolve)
  }, {
    path: '/news',
    name: 'news',
    meta: {
      title: 'user.announcement'
    },
    component: resolve => require(['@/pages/views/news/news.vue'], resolve)
  }, {
    path: '/newsShow',
    name: 'newsShow',
    meta: {
      title: 'user.announcement'
    },
    component: resolve => require(['@/pages/views/news/NewsShow.vue'], resolve)
  }, {
    path: '/newsShow/:id',
    name: 'newsShow2',
    meta: {
      title: 'user.announcement'
    },
    component: resolve => require(['@/pages/views/news/NewsShow.vue'], resolve)
  },
  // {
  //     path: '/autoTrade',
  //     name: 'autoTrade',
  //     meta: {
  //         title: '炒币机器人'
  //     },
  //     component: resolve => require(['@/pages/views/autoTrade/index.vue'], resolve)
  // },
  {
    path: '/autoTrade/history/:id',
    name: 'autoTradehistory',
    meta: {
      title: 'financial.financial'
    },
    component: resolve => require(['@/pages/views/autoTrade/history.vue'], resolve)
  },
  // v2 
  {
    path: '/autoTrade',
    name: 'autoTrade',
    meta: {
      title: 'financial.bigData'
    },
    component: resolve => require(['@/pages/views/autoTrade/trade/index.vue'], resolve)
  },
  // v3
  {
    path: '/allmill',
    name: 'allmill',
    meta: {
      title: 'financial.bigData'
    },
    component: resolve => require(['@/pages/views/allmill/trade/index.vue'], resolve)
  },

  // 用户中心
  {
    path: '/money',
    name: 'account',
    redirect: '/account/money',
    component: resolve => require(['@/pages/account/common/index.vue'], resolve),
    children: [{
        path: '/account/money',
        name: 'account.money',
        meta: {
          //我的资金
          title: 'user.money',
          requireAuth: true,
        },
        component: resolve => require(['@/pages/account/money/money.vue'], resolve)
      }, {
        path: '/account/timeMachine',
        name: 'account.security',
        meta: {
          // 安全中心
          title: 'user.security',
          requireAuth: true,
        },
        component: resolve => require(['@/pages/account/timeMachine/index.vue'], resolve)
      }, {
        path: '/account/security',
        name: 'account.security',
        meta: {
          // 安全中心
          title: 'user.security',
          requireAuth: true,
        },
        component: resolve => require(['@/pages/account/security/security.vue'], resolve)
      }, {
        path: '/account/orders',
        name: 'account.orders',
        meta: {
          // 我的挂单
          title: 'user.myOrder',
          requireAuth: true,
        },
        component: resolve => require(['@/pages/account/orders/orders.vue'], resolve)
      }, {
        path: '/account/myOrderHistory',
        name: 'account.myOrderHistory',
        meta: {
          // 成交记录
          title: 'user.dealHistory',
          requireAuth: true,
        },
        component: resolve => require(['@/pages/account/myOrderHistory/myOrderHistory.vue'], resolve)
      }, {
        path: '/account/finance',
        name: 'account.finance',
        meta: {
          // 财务记录
          title: 'user.financial',
          requireAuth: true,
        },
        component: resolve => require(['@/pages/account/finance/finance.vue'], resolve)
      },
      {
        path: '/account/lock',
        name: 'account.lock',
        meta: {
          // 锁仓记录
          title: 'user.lockHistory',
          requireAuth: true,
        },
        component: resolve => require(['@/pages/account/lock/lock/index.vue'], resolve)
      },
      {
        path: '/account/release',
        name: 'account.release',
        meta: {
          title: 'user.releaseHistory',
          requireAuth: true,
        },
        component: resolve => require(['@/pages/account/lock/release/index.vue'], resolve)
      },
      // {
      //     path: '/account/C2C',
      //     name: 'account.C2C',
      //     meta: {
      //         title: 'C2C管理',
      //         requireAuth: true,
      //     },
      //     component: resolve => require(['@/pages/account/c2c/c2c.vue'], resolve)
      // },
      {
        path: '/account/settings',
        name: 'user.personal',
        meta: {
          title: 'user.personal',
          requireAuth: true,
        },
        component: resolve => require(['@/pages/account/personal/index.vue'], resolve)
      },
      {
        path: '/account/cdd',
        name: 'account.cdd',
        meta: {
          // 实名认证
          title: 'user.certification',
          requireAuth: true,
        },
        component: resolve => require(['@/pages/account/cdd/cdd.vue'], resolve)
      }, {
        path: '/account/bank',
        name: 'account.bank',
        meta: {
          title: 'user.bankcard',
          requireAuth: true,
        },
        component: resolve => require(['@/pages/account/bank/bank.vue'], resolve)
      }, {
        path: '/account/ID_verification',
        name: 'account.ID_verification',
        meta: {
          //高级认证
          title: 'certification.senior',
          requireAuth: true,
        },
        component: resolve => require(['@/pages/account/cdd/id_verification/id_verification.vue'], resolve)
      }, {
        path: '/account/real',
        name: 'account.real',
        meta: {
          title: 'certification.identity',
          requireAuth: true,
        },
        component: resolve => require(['@/pages/account/cdd/real/real.vue'], resolve)
      }, {
        path: '/account/ordinary',
        name: 'certification.ordinaryCertification',
        meta: {
          title: 'certification.ordinaryCertification',
          requireAuth: true,
        },
        component: resolve => require(['@/pages/account/cdd/ordinary/index.vue'], resolve)
      }, {
        path: '/account/recommended',
        name: 'account.recommended',
        meta: {
          //推荐计划
          title: 'user.recommended',
          requireAuth: true,
        },
        component: resolve => require(['@/pages/account/recommended/recommended.vue'], resolve)
      },
      {
        path: '/account/referees',
        name: 'account.referees',
        meta: {
          title: '推荐关系',
          requireAuth: true,
        },
        component: resolve => require(['@/pages/account/referees/index.vue'], resolve)
      },
      {
        path: '/account/tickets',
        name: 'account.tickets',
        meta: {
          title: 'user.workorder',
          requireAuth: true,
        },
        component: resolve => require(['@/pages/account/tickets/index.vue'], resolve)
      },
    ],

  }
]



// WEBPACK FOOTER //
// ./src/router/main/index.js